import { VoiceAccountMetadata, useRestApiProvider } from "@jugl-web/rest-api";
import { useTranslations } from "@jugl-web/utils";
import { useCallback } from "react";
import { useEntitySelectedProvider } from "@web-src/modules/entities/providers/EntityProvider/useEntitySelectedProvider";
import { useVoiceAccount } from "../../../hooks/useVoiceAccount";
import { buildVoiceMetadata } from "../utils/getVoiceFormValues";

export const useUpdateVoiceSettings = () => {
  const { entityId } = useEntitySelectedProvider();
  const { account } = useVoiceAccount();
  const { integrationsApi } = useRestApiProvider();
  const { t } = useTranslations();
  const [updateVoiceConfig, { isLoading }] =
    integrationsApi.useUpdateVoiceConfigMutation();

  const updateVoiceSettings = useCallback(
    async (data: { metadata: Partial<VoiceAccountMetadata> }) => {
      try {
        await updateVoiceConfig({
          entityId,
          data: {
            metadata: buildVoiceMetadata(account, data.metadata),
          },
          meta: {
            successMessage: t({
              id: "client-support-page.voice-settings-updated",
              defaultMessage: "Phone calls settings was updated",
            }),
          },
        }).unwrap();
        return true;
      } catch {
        // Error UI handled via meta + apiResultMiddleware
        return false;
      }
    },
    [account, entityId, t, updateVoiceConfig]
  );

  return {
    updateVoiceSettings,
    isUpdatingVoiceSettings: isLoading,
  };
};
